module.exports = __webpack_public_path__ + "img/Component13–1.e966d49a.png";